export default {
  id: "l30",
  name: "L30",
  companyName: "L30",
  legalName: "L30 Ltd.",
  allowedDomains: ["latitude30.co", "l30.co"],
  subtitle: "Insights",
  logo: "/logo-l30.svg",
  favicon: "/favicon-l30.svg",
  pageTitle: "L30 Insights",
  fromEmail: "info@l30.co",
  replyToEmail: "info@l30.co",
  contactEmail: "info@l30.co",
  address: "",
  socialLinks: {
    linkedin: "",
    youtube: "",
    x: "",
    instagram: "",
    web: "",
  },
  currency: { code: "GBP", symbol: "\u00a3", locale: "en-GB" },
  features: {
    ghl: false,
    stripe: false,
    sendgrid: true,
    zoom: false,
    o365: true,
  },
  newsletter: {
    headerBg: "#005a64",
    headerText: "#f5f5f1",
    footerBg: "#003d44",
    footerText: "#8c8c8c",
    footerLink: "#f5f5f1",
    dividerColor: "#2f8f98",
    buttonBg: "#d4af37",
    buttonText: "#003d44",
    buttonLabel: "",
    buttonMergeTag: "",
    accentColor: "#d4af37",
  },
  contentBlocks: [
    // Home
    { id: "l30-hero", label: "Hero Section", page: "Home" },
    { id: "l30-thesis", label: "The Latitude30 Thesis", page: "Home" },
    { id: "l30-expertise", label: "Core Expertise Cards", page: "Home" },
    { id: "l30-cta", label: "Call to Action", page: "Home" },
    // The L30 Zone
    { id: "l30-zone-intro", label: "Zone Introduction", page: "The L30 Zone" },
    { id: "l30-zone-stats", label: "Key Statistics", page: "The L30 Zone" },
    { id: "l30-zone-mission", label: "Our Mission", page: "The L30 Zone" },
    // Services
    { id: "l30-services", label: "Services Overview", page: "Services" },
    // Sectors
    { id: "l30-sectors", label: "Sector Expertise", page: "Sectors" },
    // Contact
    { id: "l30-contact-info", label: "Contact Information", page: "Contact" },
    // Blog
    { id: "l30-blog", label: "Blog Articles", page: "Blog" },
  ],
  theme: {
    sidebar: {
      bg: "#003d44",
      bgHover: "#005a64",
      bgActive: "#005a64",
      border: "rgba(245,245,241,0.12)",
      text: "#f5f5f1",
      textSecondary: "rgba(245,245,241,0.8)",
      accent: "#d4af37",
      accentDim: "rgba(212,175,55,0.15)",
    },
    fonts: {
      heading: "'Inter', -apple-system, sans-serif",
      body: "'Inter', -apple-system, sans-serif",
    },
  },
};
